import React, { useEffect, useState } from "react";
import { icons } from "../../assets/icons";

export const BarStatusActivies = ({
	title = "Actividades completadas",
	activities = [{ title: "", isComplete: false, isCurrentAct: false }],
	styleExtra = "",
}) => {
	const [hiddenAnimation, setHiddenAnimation] = useState(false)
	useEffect(() => {
		let timeout = setTimeout(() => {
			setHiddenAnimation(true)
		}, 3000);
		return () => {
			clearTimeout(timeout)
		}
	}, [])

	useEffect(() => {
		let timeoutExtra = null;
		if (hiddenAnimation) {
			timeoutExtra = setTimeout(() => {
				const obj = document.getElementById("barStatusTaskId")
				obj.style.display = "none"
			}, 1000);

		}
		return () => {
			clearTimeout(timeoutExtra)
		}
	}, [hiddenAnimation])


	return (
		// ${hiddenAnimation ? "animate__fadeOut" : "animate__fadeIn"}
		// md:w-[320px]
		// w-[300px]
		<div id="barStatusTaskId" className={`z-30 fixed top-5 left-1/2 -translate-x-[50%] ${styleExtra} animate__animated ${hiddenAnimation ? "animate__fadeOut" : "animate__fadeIn"}`}>
			<div className="h-[60px] md:h-[65px] px-6 flex flex-col bg-[#000000ce] rounded-2xl">
				<div className="h-[40%] flex justify-center items-center ">
					<p className="text-white text-[10px] md:text-[12px]">{title}</p>
				</div>
				<div className="h-[60%] flex justify-center items-center gap-2">
					{activities.map((act, index) => {
						let jsonStyle = {
							styleCircule: "bg-[#9A9A9A]",
							img: icons.padlockblack,
						};

						if (!act.isComplete && act.isCurrentAct) {
							jsonStyle = {
								styleCircule: "bg-[#ECAE09]",
								img: icons.threepointswhite,
							};
						}

						if (act.isComplete) {
							jsonStyle = {
								styleCircule: "bg-[#009F3B]",
								img: icons.arrowmenu,
							};
						}
						return (
							<div
								key={`${index}-bar-act`}
								className={`h-6 w-6 md:h-7 md:w-7 rounded-full border-[2px] p-1 border-white ${jsonStyle.styleCircule} relative `}
							>
								<img className="h-full w-full object-contain" src={jsonStyle.img} alt="img" />
								{index !== activities.length - 1 && (
									<div className="absolute h-[2px] w-3 bg-white top-1 md:top-2 -right-2 transform translate-x-1 translate-y-1"></div>
								)}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};
